import request from '../helpers/request'
import qs from 'qs'

export default {
  getCities: async (params) => {
    try {
      const { data } = await request.get('/shop/checkout/get-cities/', { params: { city: params || '' } })

      return data
    } catch (e) {
      throw e
    }
  },
  getDeliveryMethods: async (params) => {
    try {
      const { data } = await request.get('/shop/checkout/method/', { params: params })

      return data
    } catch (e) {
      throw e
    }
  },
  getDeliveryInfo: async (params) => {
    try {
      const sendParams = { cityId: params.cityId || '', methodId: params.methodId || '' }
      if (params.client_phone) {
        sendParams.client_phone = params.client_phone
      }
      const { data } = await request.get('/shop/checkout/method-details/', { params: sendParams })

      return data
    } catch (e) {
      throw e
    }
  },
  getDeliveryStreets: async (params) => {
    try {
      const { data } = await request.get('/shop/checkout/get-streets/', { params })

      return data
    } catch (e) {
      throw e
    }
  },
  getPaymentMethods: async (params) => {
    try {
      const { data } = await request.get('/shop/checkout/get-payments/', { params })

      return data
    } catch (e) {
      throw e
    }
  },
  createOrder: async (params) => {
    try {
      const { data } = await request.post('/shop/checkout/create-order/', qs.stringify({ order: params }))

      return data
    } catch (e) {
      throw e
    }
  }
  // setCommunications: async (formData) => {
  //   try {
  //     const { data } = await request.post('/cabinet/profile/set-preferred-communication/', formData)
  //
  //     return data
  //   } catch (e) {
  //     throw e
  //   }
  // }
}
